// tslint:disable: no-namespace
// tslint:disable: max-line-length
export namespace UI {

    /** Back */
    export const UI12 = "lsf_ui12";
    /** Home */
    export const UI11 = "lsf_ui11";
    /** New City */
    export const UI9 = "lsf_ui09";

    export namespace LANDING_PAGE {
        /** Luna’s Seek & Find! */
        export const UI1 = "lsf_ui01";
        /** Play */
        export const UI7 = "lsf_ui07";
    }

    export namespace CITY_SELECT {
        /** Let’s go help my friends all over the world. */
        export const UI2B = "lsf_ui02b";
        /** Pick a city on the map to go to. */
        export const UI3 = "lsf_ui03";
        /** Choose a city to visit! */
        export const UI4 = "lsf_ui04";
        /** Ooooo, which city should we go to next? */
        export const UI5 = "lsf_ui05";
        /** There are friends to share experiences with all over the world! */
        export const UI6 = "lsf_ui06";
        /** Juneau, Alaska in the United States */
        export const UI16ALT = "lsf_ui16alt";
        /** Paris, France */
        export const UI17 = "lsf_ui17";
        /** London, United Kingdom */
        export const UI18ALT = "lsf_ui18alt";
        /** Rio de Janeiro, Brazil */
        export const UI19 = "lsf_ui19";
        /** New Orleans, Louisiana in the United States */
        export const UI20ALT = "lsf_ui20alt";
    }

    export namespace GIVE {
        /** Continue */
        export const UI10 = "lsf_ui10";
        /** Select here to go! */
        export const O2 = "lsf_o02";
    }

    export namespace RETURN {
        /** Next */
        export const UI8 = "lsf_ui08";
    }

    export namespace EXTERIOR {
        /** Hint */
        export const UI13 = "lsf_ui13";
        /** Right */
        export const UI14 = "lsf_ui14";
        /** Left */
        export const UI15 = "lsf_ui15";
    }

}

export namespace ONBOARDING {
    /** Hi friend! Let’s go help my friends all over the world. */
    export const UI2 = "lsf_ui02";
    /** How about we visit Juneau, Alaska in the United States, first! */
    export const O1 = "lsf_o01";
    /** If you need help finding something, use this button for a hint. */
    export const O3 = "lsf_o03";
    /** Use the arrow buttons to move left or right! */
    export const O4 = "lsf_o04";
}

export namespace LUNA {
    /** Great! */
    export const A1 = "lsf_a01";
    /** Cool! */
    export const A2 = "lsf_a02";
    /** Nice find! */
    export const A3 = "lsf_a03";
    /** Wow! */
    export const A4 = "lsf_a04";
    /** Wohooo! */
    export const A5 = "lsf_a05";
    /** Great find! */
    export const A6 = "lsf_a06";
    /** Whoa! */
    export const A7 = "lsf_a07";
    /** Way to go! */
    export const A8 = "lsf_a08";
    /** Great job! */
    export const A9 = "lsf_a09";
    /** Just one more thing on our list to find. */
    export const A10 = "lsf_a10";
    /** Just one more wild animal on our list to find. */
    export const A11 = "lsf_a11";
    /** Hmmm, let’s keep looking. */
    export const A12 = "lsf_a12";
    /** Let’s look somewhere else. */
    export const A13 = "lsf_a13";
    /** I wonder where we should look next. */
    export const A14 = "lsf_a14";
    /** How about we look in a new spot? */
    export const A15 = "lsf_a15";
    /** Need a hint? Use this button. */
    export const A16 = "lsf_a16";
}

export namespace JUNEAU {
    export namespace GIVE {
        /** Hi friend – we’re in Juneau, Alaska where there are SO many wild animals to see! */
        export const J1 = "lsf_j01";
        /** My friend Skye needs our help taking animal photos for her picture board. */
        export const J2 = "lsf_j02";
        /** Let’s go into the wild and take some pictures! */
        export const J3 = "lsf_j03";
        /** Ooooh - I can’t wait to take some photos! */
        export const J4 = "lsf_j04";
        /** Ooooh - I wonder what wild animals we’ll find! */
        export const J5 = "lsf_j05";

    }

    export namespace RETURN {
        /** Wooohoooo – we took all of the pictures Skye needed! */
        export const J8 = "lsf_j08";
        /** Now, let’s put them on her picture board. */
        export const J9 = "lsf_j09";
        /** Wow, I really love these! */
        export const J10 = "lsf_j10";
        /** Such beautiful pictures! */
        export const J11 = "lsf_j11";
        /** You took some great shots! */
        export const J12 = "lsf_j12";
        /** Oooh - should we take more wild animal photos in Juneau or go visit another city? */
        export const J13 = "lsf_j13";
    }

    export namespace EXTERIOR {
        /** Isn’t Juneau, Alaska a beautiful place??! */
        export const J6 = "lsf_j06";
        /** When you find a wild animal on our list, select it to take a picture! */
        export const J7 = "lsf_j07";
    }

    export namespace ITEMS {
        /** Bear. */
        export const IJ1A = "lsf_ij01a";
        /** Bear! */
        export const IJ1B = "lsf_ij01b";
        /** Woodpecker. */
        export const IJ2A = "lsf_ij02a";
        /** Woodpecker! */
        export const IJ2B = "lsf_ij02b";
        /** Porcupine. */
        export const IJ3A = "lsf_ij03a";
        /** Porcupine! */
        export const IJ3B = "lsf_ij03b";
        /** Beaver. */
        export const IJ4A = "lsf_ij04a";
        /** Beaver! */
        export const IJ4B = "lsf_ij04b";
        /** Bald Eagle. */
        export const IJ5A = "lsf_ij05a";
        /** Bald Eagle! */
        export const IJ5B = "lsf_ij05b";
        /** Moose. */
        export const IJ6A = "lsf_ij06a";
        /** Moose! */
        export const IJ6B = "lsf_ij06b";
        /** Turtle. */
        export const IJ7A = "lsf_ij07a";
        /** Turtle! */
        export const IJ7B = "lsf_ij07b";
        /** Raven. */
        export const IJ8A = "lsf_ij08a";
        /** Raven! */
        export const IJ8B = "lsf_ij08b";
        /** Snail. */
        export const IJ9A = "lsf_ij09a";
        /** Snail! */
        export const IJ9B = "lsf_ij09b";
        /** Deer. */
        export const IJ10A = "lsf_ij10a";
        /** Deer! */
        export const IJ10B = "lsf_ij10b";
    }

    export namespace FACTS {
        /** Alaska is the largest state in the United States. */
        export const FJ1 = "lsf_fj01";
        /** Alaska has the top ten tallest mountains in the United States. */
        export const FJ2 = "lsf_fj02";
        /** Alaska has about twelve thousand rivers and three million lakes. */
        export const FJ3 = "lsf_fj03";
        /** Juneau is the capital of Alaska. */
        export const FJ4 = "lsf_fj04";
        /** Juneau is famous for its beautiful ice caves. */
        export const FJ5 = "lsf_fj05";
        /** Black Bears fish for salmon in streams. */
        export const FJ6 = "lsf_fj06";
        /** The Red-breasted Sapsucker is a woodpecker that drills holes in trees to eat sap and insects. */
        export const FJ7 = "lsf_fj07";
        /** Beavers and porcupines are the two largest rodents in Alaska. */
        export const FJ8 = "lsf_fj08";
        /** Porcupines eat tree bark during the winter. */
        export const FJ9 = "lsf_fj09";
        /** The bald eagle is the national bird of the United States. */
        export const FJ10 = "lsf_fj10";
        /** There are more bald eagles in Alaska than in any other state in the United States. */
        export const FJ11 = "lsf_fj11";
        /** Deer enjoy nibbling on a smelly plant called a Skunk Cabbage. */
        export const FJ12 = "lsf_fj12";
        /** Ravens are very smart birds that play games with sticks. */
        export const FJ13 = "lsf_fj13";
    }
}

export namespace LONDON {
    export namespace GIVE {
        /** Here we are in London, United Kingdom with the Wigglewalkers! */
        export const L1 = "lsf_l01";
        /** They’re getting ready for a big circo performance and need our help finding new things to juggle. */
        export const L2 = "lsf_l02";
        /** C’mon - let’s go see what we can find in London! */
        export const L3 = "lsf_l03";
        /** Oooh - I can’t wait to look in London! */
        export const L4 = "lsf_l04";
        /** Oooh - I wonder what we’ll find! */
        export const L5 = "lsf_l05";
    }
    export namespace EXTERIOR {
        /** Ah, lovely London, England – isn’t it groovy? */
        export const L6 = "lsf_l06";
        /** When you find something on our list, select it! */
        export const L7 = "lsf_l07";
    }
    export namespace RETURN {
        /** Woohoo- we’re back just in time for the big juggling performance. */
        export const L8 = "lsf_l08";
        /** Quick – give them the new things to juggle. */
        export const L9 = "lsf_l09";
        /** <giggle> That really is amazing juggling! */
        export const L10 = "lsf_l10";
        /** Don’t you just LOVE juggling? It’s one of my favorite things to watch! */
        export const L11 = "lsf_l11";
        /** Juggling! (cheers) WOO WOO WOO! */
        export const L12 = "lsf_l12";
        /** Oooh - should we look for more things in London to juggle or go visit another city? */
        export const L13 = "lsf_l13";
    }
    export namespace ITEMS {
        /** Shepherd's Pie. */
        export const IL1A = "lsf_il01a";
        /** Shepherd’s Pie! */
        export const IL1B = "lsf_il01b";
        /** Football. */
        export const IL2A = "lsf_il02a";
        /** Football! */
        export const IL2B = "lsf_il02b";
        /** Teapot. */
        export const IL3A = "lsf_il03a";
        /** Teapot! */
        export const IL3B = "lsf_il03b";
        /** Candyfloss. */
        export const IL4A = "lsf_il04a";
        /** Candyfloss! */
        export const IL4B = "lsf_il04b";
        /** Crisps. */
        export const IL5A = "lsf_il05a";
        /** Crisps! */
        export const IL5B = "lsf_il05b";
        /** Double Decker Bus. */
        export const IL6A = "lsf_il06a";
        /** Double Decker Bus! */
        export const IL6B = "lsf_il06b";
        /** Fish n Chips. */
        export const IL7A = "lsf_il07a";
        /** Fish n Chips! */
        export const IL7B = "lsf_il07b";
        /** Biscuits. */
        export const IL8A = "lsf_il08a";
        /** Biscuits! */
        export const IL8B = "lsf_il08b";
        /** Umbrella. */
        export const IL9A = "lsf_il09a";
        /** Umbrella! */
        export const IL9B = "lsf_il09b";
        /** Bangers and Mash. */
        export const IL10A = "lsf_il10a";
        /** Bangers and Mash! */
        export const IL10B = "lsf_il10b";
    }
    export namespace FACTS {
        /** The city of London is over 2000 years old. */
        export const FL1 = "lsf_fl01";
        /** London is the capital of the United Kingdom. */
        export const FL2 = "lsf_fl02";
        /** Tea is very popular in the United Kingdom, where they drink 60 billion cups a year! */
        export const FL3 = "lsf_fl03";
        /** People in London have been eating fish and chips for over 150 years! */
        export const FL4 = "lsf_fl04";
        /** Shepherd’s Pie is made with potatoes and meat, so it’s not sweet like other pies. */
        export const FL5 = "lsf_fl05";
        /** Bangers and mash is a dish made of sausages and mashed potatoes. */
        export const FL6 = "lsf_fl06";
        /** Football is called soccer in the United States. */
        export const FL7 = "lsf_fl07";
        /** Crisps are called potato chips in the United States. */
        export const FL8 = "lsf_fl08";
        /** (laughs) Candyfloss is called Cotton Candy in the United States. */
        export const FL9 = "lsf_fl09";
        /** Biscuits are called cookies in the United States. */
        export const FL10 = "lsf_fl10";
   }
}

export namespace PARIS {
    /** Hiii friend, we’re in Paris, France, with endless food possibilities! */
    export const P1 = "lsf_p01";
    /** Chef René needs our help finding ingredients to make a special French dish! */
    export const P2 = "lsf_p02";
    /** Let’s go to the Paris Market and find some ingredients. */
    export const P3 = "lsf_p03";
    /** Come on. Let’s go! I’m starving! */
    export const P4 = "lsf_p04";
    /** I wonder which French dish Chef Rene is going to make. */
    export const P5 = "lsf_p05";
    /** Oooh, the Paris Market… just look at all the shops and foods we can try! */
    export const P6 = "lsf_p06";
    /** When you find an ingredient on our list, select it! */
    export const P7 = "lsf_p07";
    /** Great job! We found everything on Chef René’s list! */
    export const P8 = "lsf_p08";
    /** Now, let’s put the ingredients on the counter to see what Chef René’s going to make! */
    export const P9 = "lsf_p09";
    /** Oooooh - a Grilled Cheese Sandwich – with yummy, stretchy cheese! */
    export const P10 = "lsf_p10";
    /** Duck Confit - a delicious French dish! */
    export const P11 = "lsf_p11";
    /** Oooh, French Onion Soup! */
    export const P12 = "lsf_p12";
    /** Wow, Mussels with tomato sauce! */
    export const P13 = "lsf_p13";
    /** Ratatouille – one of my favorite French dishes. YUM! */
    export const P14 = "lsf_p14";
    /** Hmm - should we make another dish with Chef René or go visit a new city? */
    export const P15 = "lsf_p15";
    /** Tomato. */
    export const IP1A = "lsf_ip01a";
    /** Tomato! */
    export const IP1B = "lsf_ip01b";
    /** Sourdough Bread. */
    export const IP2A = "lsf_ip02a";
    /** Sourdough Bread! */
    export const IP2B = "lsf_ip02b";
    /** Cheese. */
    export const IP3A = "lsf_ip03a";
    /** Cheese! */
    export const IP3B = "lsf_ip03b";
    /** Butter. */
    export const IP4A = "lsf_ip04a";
    /** Butter! */
    export const IP4B = "lsf_ip04b";
    /** Drumstick. */
    export const IP5A = "lsf_ip05a";
    /** Drumstick! */
    export const IP5B = "lsf_ip05b";
    /** Duck. */
    export const IP6A = "lsf_ip06a";
    /** Duck! */
    export const IP6B = "lsf_ip06b";
    /** Garlic. */
    export const IP7A = "lsf_ip07a";
    /** Garlic! */
    export const IP7B = "lsf_ip07b";
    /** Parsley. */
    export const IP8A = "lsf_ip08a";
    /** Parsley! */
    export const IP8B = "lsf_ip08b";
    /** Onion. */
    export const IP9A = "lsf_ip09a";
    /** Onion! */
    export const IP9B = "lsf_ip09b";
    /** Mussels. */
    export const IP10A = "lsf_ip10a";
    /** Mussels! */
    export const IP10B = "lsf_ip10b";
    /** Basil. */
    export const IP11A = "lsf_ip11a";
    /** Basil! */
    export const IP11B = "lsf_ip11b";
    /** Onion. */
    export const IP12A = "lsf_ip12a";
    /** Onion! */
    export const IP12B = "lsf_ip12b";
    /** Beet. */
    export const IP13A = "lsf_ip13a";
    /** Beet! */
    export const IP13B = "lsf_ip13b";
    /** Eggplant. */
    export const IP14A = "lsf_ip14a";
    /** Eggplant! */
    export const IP14B = "lsf_ip14b";
    /** Bell Pepper. */
    export const IP15A = "lsf_ip15a";
    /** Bell Pepper! */
    export const IP15B = "lsf_ip15b";
    /** People who live in Paris are called Parisians. */
    export const FP1 = "lsf_fp01";
    /** Parisians often go to many different shops to buy ingredients for their meals. */
    export const FP2 = "lsf_fp02";
    /** Paris is famous for its great cooking schools. */
    export const FP4 = "lsf_fp04";
    /** In France, a bread shop is called boulangerie. */
    export const FP5 = "lsf_fp05";
    /** In France, a cheese shop is called fromagerie. */
    export const FP6 = "lsf_fp06";
    /** In France, a meat shop is called boucherie. */
    export const FP7 = "lsf_fp07";
    /** Ratatouille is a popular French stew made with vegetables and sometimes meat. */
    export const FP8 = "lsf_fp08";
    /** French onion soup is just called ‘onion soup’ in France. */
    export const FP9 = "lsf_fp09";
    /** France is famous for having hundreds of kinds of cheese. */
    export const FP10 = "lsf_fp10";
}

export namespace NEW_ORLEANS {
    /** Here we are in New Orleans, Louisiana – a very musical city! */
    export const N1 = "lsf_n01";
    /** My friend Dexter needs our help finding the instruments he lost. */
    export const N2 = "lsf_n02";
    /** Let’s go look for them! */
    export const N3 = "lsf_n03";
    /** Come on – let’s find Dexter’s instruments. */
    export const N4 = "lsf_n04";
    /** Oooh - I wonder what jazz instruments we’ll find! */
    export const N5 = "lsf_n05";
    /** Isn’t New Orleans wonderful?! */
    export const N6 = "lsf_n06";
    /** When you find an instrument on our list, select it! */
    export const N7 = "lsf_n07";
    /** Great job – we found Dexter’s missing instruments! */
    export const N8 = "lsf_n08";
    /** Let’s help him put them back in his van. */
    export const N9 = "lsf_n09";
    /** Woohooo – now Dexter can play jazz music again! */
    export const N10 = "lsf_n10";
    /** Oooh – I wonder what Dexter will play. The possibilities are endless with jazz! */
    export const N11 = "lsf_n11";
    /** Great! (happy sigh) Isn’t helping friends the best? */
    export const N12 = "lsf_n12";
    /** Should we look for more instruments in New Orleans or go visit a new city? */
    export const N13 = "lsf_n13";
    /** Drum Kit. */
    export const IN1A = "lsf_in01a";
    /** Drum Kit! */
    export const IN1B = "lsf_in01b";
    /** Sousaphone. */
    export const IN2A = "lsf_in02a";
    /** Sousaphone! */
    export const IN2B = "lsf_in02b";
    /** Saxophone. */
    export const IN3A = "lsf_in03a";
    /** Saxophone! */
    export const IN3B = "lsf_in03b";
    /** Trumpet. */
    export const IN4A = "lsf_in04a";
    /** Trumpet! */
    export const IN4B = "lsf_in04b";
    /** Guitar. */
    export const IN5A = "lsf_in05a";
    /** Guitar! */
    export const IN5B = "lsf_in05b";
    /** Clarinet. */
    export const IN6A = "lsf_in06a";
    /** Clarinet! */
    export const IN6B = "lsf_in06b";
    /** Trombone. */
    export const IN7A = "lsf_in07a";
    /** Trombone! */
    export const IN7B = "lsf_in07b";
    /** Bass. */
    export const IN8A = "lsf_in08a";
    /** Bass! */
    export const IN8B = "lsf_in08b";
    /** Flute. */
    export const IN9A = "lsf_in09a";
    /** Flute! */
    export const IN9B = "lsf_in09b";
    /** Drumsticks. */
    export const IN10A = "lsf_in10a";
    /** Drumsticks! */
    export const IN10B = "lsf_in10b";
    /** New Orleans is a famous city where jazz music was born. */
    export const FN1 = "lsf_fn01";
    /** Jazz is a kind of American music, known for its improvisation, where you make up the music as you play. */
    export const FN2 = "lsf_fn02";
    /** One of America’s greatest jazz musicians, Louis Armstrong, was born in New Orleans. */
    export const FN3 = "lsf_fn03";
    /** New Orleans is a city built along the Mississippi River. */
    export const FN4 = "lsf_fn04";
    /** You can find musicians performing music in the streets of New Orleans. */
    export const FN5 = "lsf_fn05";
    /** The drum kit allows drummers to play with their hands and feet at the same time. */
    export const FN6 = "lsf_fn06";
    /** The trombone is played by blowing into its mouthpiece, while moving a slide in and out to change the notes. */
    export const FN7 = "lsf_fn07";
    /** Bass fiddle players usually hold their instruments upright when they play. */
    export const FN8 = "lsf_fn08";
    /** The saxophone and clarinet have reeds in their mouthpieces, which create their unique sounds. */
    export const FN9 = "lsf_fn09";
    /** Saxophones come in different sizes, from the soprano (for playing the highest notes), to the baritone (for playing the lowest notes). */
    export const FN10 = "lsf_fn10";
    /** Trumpets and trombones are played by making a ‘buzzing’ or ‘raspberry’ sound with your lips while blowing into the mouthpiece. */
    export const FN11 = "lsf_fn11";
}

export namespace RIO {
    /** Bon Gio! Welcome to Rio de Janeiro, Brazil! */
    export const R1 = "lsf_r01";
    /** My friend Raquel is getting her float ready for a special festival named Carnival! */
    export const R2 = "lsf_r02";
    /** Let’s help her find supplies to finish the float! */
    export const R3 = "lsf_r03";
    /** Ooooh - I can’t wait to see what parade float Raquel creates. */
    export const R4 = "lsf_r04";
    /** (laughs) I wonder what supplies we’ll find in the warehouse! */
    export const R5 = "lsf_r05";
    /** Wow - a Samba City Warehouse – with so many parade float supplies! */
    export const R6 = "lsf_r06";
    /** When you find a float supply on our list, select it! */
    export const R7 = "lsf_r07";
    /** Great job – we found all of Raquel’s supplies! */
    export const R8 = "lsf_r08";
    /** Let’s put them below to help finish the float. */
    export const R9 = "lsf_r09";
    /** WOW – this Carnival float is beautiful! */
    export const R10 = "lsf_r10";
    /** I really love this Carnival float! */
    export const R11 = "lsf_r11";
    /** Oooh! Isn’t working and creating with your friends just amazing? */
    export const R12 = "lsf_r12";
    /** Should we help make another float in Rio de Janeiro or go visit another city? */
    export const R13 = "lsf_r13";
    /** Paint Brush. */
    export const IR1A = "lsf_ir01a";
    /** Paint Brush! */
    export const IR1B = "lsf_ir01b";
    /** Sewing Machine. */
    export const IR2A = "lsf_ir02a";
    /** Sewing Machine! */
    export const IR2B = "lsf_ir02b";
    /** Ruler. */
    export const IR3A = "lsf_ir03a";
    /** Ruler! */
    export const IR3B = "lsf_ir03b";
    /** Paint Palette. */
    export const IR4A = "lsf_ir04a";
    /** Paint Palette! */
    export const IR4B = "lsf_ir04b";
    /** Cardboard. */
    export const IR5A = "lsf_ir05a";
    /** Cardboard! */
    export const IR5B = "lsf_ir05b";
    /** Tape Measure. */
    export const IR6A = "lsf_ir06a";
    /** Tape Measure! */
    export const IR6B = "lsf_ir06b";
    /** Paint Bucket. */
    export const IR7A = "lsf_ir07a";
    /** Paint Bucket! */
    export const IR7B = "lsf_ir07b";
    /** Glue. */
    export const IR8A = "lsf_ir08a";
    /** Glue! */
    export const IR8B = "lsf_ir08b";
    /** Tape. */
    export const IR9A = "lsf_ir09a";
    /** Tape! */
    export const IR9B = "lsf_ir09b";
    /** The Carnival celebration in Rio de Janeiro is often called “The Greatest Show on Earth!” */
    export const FR1 = "lsf_fr01";
    /** During Carnival, samba schools compete to see who can make the best parade floats. */
    export const FR2 = "lsf_fr02";
    /** Samba is a style of Brazilian music and dance featured during Carnival. */
    export const FR3 = "lsf_fr03";
    /** Samba City is an area of Rio de Janeiro where teams build floats and practice routines in large warehouses to get ready for Carnival. */
    export const FR4 = "lsf_fr04";
    /** Samba schools work all year to build floats, write songs, sew costumes and practice dances for the Carnival competition. */
    export const FR5 = "lsf_fr05";
    /** Tape measures are flexible rulers that are useful when working on large parade floats. */
    export const FR6 = "lsf_fr06";
    /** Paint brushes are often made from the hair of animals, like hogs, horses, goats and badgers. */
    export const FR7 = "lsf_fr07";
    /** Sewing machines are often used to stitch together pieces of cloth to make costumes. */
    export const FR8 = "lsf_fr08";
    /** Glue is used to stick objects together when building a float. */
    export const FR9 = "lsf_fr09";
    /** Artists sometimes mix colors on a paint palette. */
    export const FR10 = "lsf_fr10";
    /** A parade float is a large moving platform on which artists often build a beautiful scene for people to enjoy. */
    export const FR11 = "lsf_fr11";
    /** In Rio de Janeiro’s Carnival, dancers often dance on the floats as they move down the parade route. */
    export const FR12 = "lsf_fr12";
}
